import I18N from '@leverege/i18n';
import AggsViewModel from "./models/AggsViewModel.js";
import AggsPieChartSupportDataViewer from "./AggsPieChartSupportDataViewer.js";
import AggregationsContainerView from "./AggregationsContainerView.js";
import DataViewerModel from "../DataViewerModel.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.aggregations.AggregationsPieChartDataViewer');
export default {
  id: 'molten.dataViewers.aggregations.AggregationsPieChartDataViewer',
  type: 'molten.AggregationsPieChartContainer',
  name: tf('aggregationsPieChart'),
  icon: tfIcon('configIcon'),
  layout: {
    section: tf('section'),
    sort: 'c.b'
  },
  location: ['main', 'card'],
  matches: {
    type: 'GroupDataViewer'
  },
  settingsUpdaters: DataViewerModelUpdaterCreator.create('AggregationsViewModelUpdater'),
  createSettings: props => {
    return AggsViewModel.create({
      dataViewers: [DataViewerModel.create(AggsPieChartSupportDataViewer.type, AggsPieChartSupportDataViewer.createSettings(props))],
      breakpoints: []
    }, ['Filter', 'Stats']);
  },
  component: AggregationsContainerView,
  getDefaultCardContentOptions: {
    height: '400px'
  }
};